export const inventoryStatus = {
  LOW_INVENTORY: 'LOW_INVENTORY',
  PENDING: 'PENDING',
  SUFFICIENT_INVENTORY: 'SUFFICIENT_INVENTORY',
};
